import React, { Component } from 'react';
import { Button, Spin, Table, Tag, notification, Col, Row, Modal, message, Icon } from 'antd';
import moment from 'moment';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';

class ViewCenterBatchLabCountData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerList: [],
      ExamDateList: [],
      Data: [],
      selectedCenter: null,
      selectedExamDate: null,
      loading: false,
      totalCount:0,
      showDeleteConfirm: false,
    };

  }

  componentDidMount() {
    this.fetchCenters();
  }

  //Converts an array into objects with Id and Name keys for dropdown options.
  transformArray = (responseArray) => {
    return responseArray.map((item) => ({
      Id: item,
      Name: item,
    }));
  };

  // Fetch centers when the page loads
  fetchCenters = async () => {

    this.setState({ loading: true });
    try {
      const response = await _AdminService.GetDistinctCenterFromBatchLabCount();   // Assuming API returns data in response.data
      // console.log(response.data);
      this.setState({ centerList: this.transformArray(response.data), loading: false });
      console.log(this.state.centerList);
    } catch (error) {
      this.setState({ loading: false });
      // notification.error({ message: 'Error fetching centers', description: error.message });
    }
  };

  handleCenterChange = async (event) => {

    this.setState({ selectedCenter: event.target.value, ExamDateList: [], Data: [], selectedExamDate: null, totalCount: 0, loading: true });
    try {
      // Fetch batches based on selected center
      const response = await _AdminService.GetDistinctExamDateByCenterName(event.target.value);
      console.log(response.data);

      this.setState({ ExamDateList: this.transformArray(response.data), loading: false });
      // console.log(this.state.batchList);

    } catch (error) {

      this.setState({ loading: false });

      //notification.error({ message: 'Error fetching dates', description: error.message });
    }
  };


  // handledateChange = async (event) => {

  //   this.setState({ selectedExamDate: event.target.value, loading: true, Data: [] });
  //   try {

  //     const response = await _AdminService.GetAllCenterBatchLabCountDataByCenterAndDate(this.state.selectedCenter, event.target.value);

  //     this.setState({ Data: response.data, loading: false });
  //     console.log(this.state.Data);

  //   } catch (error) {
  //     this.setState({ loading: false });
  //     //notification.error({ message: 'Error fetching data', description: error.message });
  //   }
  // };


  handledateChange = async (event) => {
    const selectedExamDate = event.target.value;

    // If the selected date is empty or "Select ExamDate", reset the state
    if (selectedExamDate === "Select ExamDate" || selectedExamDate === "") {
      this.setState({ selectedExamDate, Data: [], totalCount: 0, loading: false });
      return;
    }

    // Set loading to true before making the API request
    this.setState({ selectedExamDate, loading: true });

    try {
      // Fetch data based on the selected center and date
      const response = await _AdminService.GetAllCenterBatchLabCountDataByCenterAndDate(this.state.selectedCenter, event.target.value);

      // Ensure the response contains valid data before updating the state
      if (response.data) {
        this.setState({ Data: response.data, totalCount: response.data.length, loading: false });
      }
    } catch (error) {
      // Handle any errors (optional: notify the user)
      this.setState({ loading: false });
      console.error("Error fetching data:", error); // You can replace this with a notification or log as needed
    }
  };



  onViewClick = async (record) => {
    try {
      this.setState({ isLoading: true });

      const response = await _AdminService.GetStudentDataForAttendance(record.StartRoleNumber, record.EndRoleNumber);
      console.log(response);

      const candidates = response.data.Obj;
      const updatedCandidates = candidates.map((candidate) => ({
        ...candidate,
        candidateSignature: "",
        candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim(),
      }));

      this.setState({
        isLoading: false,
      });

    } catch (e) {
      console.error("Error:", e);
      this.setState({ isLoading: false });
    }
  };

  DeleteCenterBatchLabCountData = async () => {
    this.setState({ loading: true });
    try {
      const response = await _AdminService.DeleteCenterBatchLabCountData();

      if (response.data.IsSuccess) {
        this.setState({
          centerList: [],
          ExamDateList: [],
          Data: [],
          selectedCenter: null,
          selectedExamDate: null,
          loading: false
        });
      } else {
        this.setState({ loading: false });
      }
      console.log("response", response)
      this.setState({ loading: false }); // Set state in one call

    } catch (error) {
      console.error('Error deleting student center batch lab count data:', error);
    }
  };


  handleDeleteConfirmation = () => {
    this.setState({ showDeleteConfirm: true });
  };

  render() {
    const { centerList, ExamDateList, Data, loading } = this.state;

    const TableColumns = [
      // {
      //   title: 'ID',
      //   dataIndex: 'Id',
      //   key: 'Id',
      //   width: '5%',
      //   sorter: (a, b) => a.Id - b.Id
      // },
      {
        title: 'Center',
        dataIndex: 'Center',
        key: 'Center',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.Center.localeCompare(b.Center)
      },
      {
        title: 'Server',
        dataIndex: 'Server',
        key: 'Server',
        width: '13%',
        filterSearch: true,
        sorter: (a, b) => a.Server.localeCompare(b.Server)
      },
      {
        title: 'Building Name',
        dataIndex: 'BuildingName',
        key: 'BuildingName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BuildingName.localeCompare(b.BuildingName)
      },
      {
        title: 'Floor',
        dataIndex: 'Floor',
        key: 'Floor',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.Floor.localeCompare(b.Floor)
      },
      {
        title: 'Lab Name',
        dataIndex: 'LABName',
        key: 'LABName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.LABName.localeCompare(b.LABName)
      },
      {
        title: 'Nodes',
        dataIndex: 'Nodes',
        key: 'Nodes',
        width: '8%',
        sorter: (a, b) => a.Nodes - b.Nodes
      },
      {
        title: 'Exam Date',
        dataIndex: 'ExamDate',
        key: 'ExamDate',
        width: '10%',
        render: (text, record) => moment(record.ExamDate).isValid() ? moment(record.ExamDate).format('DD-MMM-YYYY') : '',
        sorter: (a, b) => moment(a.ExamDate).unix() - moment(b.ExamDate).unix()
      },
    ];


    return (
      <Spin spinning={loading}>
        <div className="container-fluid p-3">
          <PageHeader
            title="View Center Batch Lab Count Data"
            breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Attendance' }, { label: 'View Center Batch Lab Count Data' }]}
          />
          <div className="ent-panel mb-3">
            <Row gutter={16} className="m-0 d-flex align-items-center">
              <Col span={4} className="d-flex align-items-center">
                <label htmlFor="center" className="mb-0 mr-2">Center:</label>
                <DropdownList
                  id="center"
                  placeholder="Select Center"
                  options={centerList}
                  onChange={this.handleCenterChange}
                  value={this.state.selectedCenter}
                  name="Center"
                  wrapClass="w-100  mb-0"
                />
              </Col>
              <Col span={4} className="d-flex align-items-center">
                <label htmlFor="center" className="mb-0 mr-2">ExamDate:</label>
                <DropdownList
                  wrapClass="w-100 mb-0"
                  id="examdate"
                  placeholder="Select ExamDate"
                  options={ExamDateList}
                  onChange={this.handledateChange}
                  value={this.state.selectedExamDate}
                  name="examdate"
                  disabled={!this.state.selectedCenter}
                />
              </Col>
              <Col span={6} style={{ marginLeft: "25px", fontWeight: "bold" }}>
                Total Records : {this.state.totalCount}
              </Col>
              <Col span={9} className="d-flex align-items-center justify-content-end pr-0">
                <a
                  type="primary"
                  danger
                  className="button-global button-border removebutton addbutton autoWidth d-inline-block text-center autoHeight"
                  onClick={this.handleDeleteConfirmation}
                >
                  <Icon type="delete" className="mr-2 align-middle mb-1" />
                  Delete Candidate Center Batch Lab Count Data
                </a>
              </Col>
            </Row>
            <div className="mt-3">
              <Table
                size="small"
                columns={TableColumns}
                dataSource={this.state.Data}
                rowKey="Id"
                pagination={false}
                className="table-striped-rows admin-table "
              />
            </div>
          </div>
        </div>
        <Modal
          footer={false}
          onCancel={() => this.setState({ showDeleteConfirm: false })}
          visible={this.state.showDeleteConfirm}
          className="modelPopAnt admin-home"
        >
          <ConfirmPopup
            message="Are you sure? Do you want to delete the student center batch lab count data?"
            onCancel={() => {
              console.log("Operation canceled.");
              this.setState({ showDeleteConfirm: false });
            }}
            onOk={() => {
              this.setState({ showDeleteConfirm: false });
              return new Promise((resolve, reject) => {
                this.DeleteCenterBatchLabCountData()
                  .then(() => {
                    message.success("Candidate center batch lab count data deleted successfully!");
                    resolve();
                  })
                  .catch((error) => {
                    message.error("Failed to delete student center batch lab count data.");
                    console.error("Failed to delete student center batch lab count data:", error);
                    reject();
                  });
              });
            }}
          />
        </Modal>
      </Spin>
    );
  }
}
export default ViewCenterBatchLabCountData;




